var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchProductsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.88023 9.52023C7.89055 9.52023 9.52023 7.89055 9.52023 5.88023C9.52023 3.86992 7.89055 2.24023 5.88023 2.24023C3.86992 2.24023 2.24023 3.86992 2.24023 5.88023C2.24023 7.89055 3.86992 9.52023 5.88023 9.52023Z",
    stroke: "#808080",
    strokeWidth: 0.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.68018 8.68018L11.7602 11.7602",
    stroke: "#808080",
    strokeWidth: 0.84,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchProductsIcon);
export default __webpack_public_path__ + "static/media/search-products-icon.b912360de4d98b7948eadd3153be6887.svg";
export { ForwardRef as ReactComponent };